import styled from 'styled-components';
import { Select, Button, Input, Checkbox } from 'antd';
import { Picky } from 'react-picky';

import 'react-picky/dist/picky.css';
const CheckboxGroup = Checkbox.Group;


export const StyledAppdiv = styled.div`
  border-radius: 5px;  
  background-color:  ${(props) => props.contentBgColor ? props.contentBgColor : 'rgb(39, 43, 52)'} !important;
`;

export const RuleTypeSelectionDiv = styled.div`
  padding-left: 1%;
  margin-top: 1%;
  display: -webkit-inline-box;
`;

export const BlockedLabel = styled.label`
  display: block;
  font-weight: 700;
  margin-bottom: 7px;
`;

export const BlockedLabelBlack = styled.label`
  display: block;
  font-weight: 700;
  margin-bottom: 7px;
`;
export const BlockedParaBlack = styled.p`
  display: block;
  font-weight: 700;
  margin-bottom: 0px;
`;
export const ConditionSelect = styled(Select)`
  width: 120px;
  display: block;
  margin-bottom: 1%;
  margin-left: 29.2%;
  margin-right: 1% !important;
`;
export const StyledSpan = styled.span`
  font-weight: 700;
`;

export const TableConditionSelect = styled(Select)`
  width: 120px;
  display: block;
  margin-bottom: 1%;
  margin-left: 24.8%;
`;


export const GoBackButton = styled(Button)`
  margin: 1%;
  font-weight: bold !important;
`;

export const RestConditionSelect = styled(Select)`
  width: 120px;
  display: block;
  margin-bottom: 1%;
  margin-left: 21.1%;
`;

export const ActionSelectionDiv = styled.div`
  margin-bottom: 1%;
  margin-top: 1%;
  border: 2px dotted gray;
  display: inline-block;
  padding: 10px;
`;

export const AddParagraph = styled.p`
  float: right;
  margin-right: 1%;
  font-weight: 700;
  
`;

export const BlankDiv = styled.div`
  margin-bottom: 1%;
  margin-left: 1%;
  display: inline-block;
  padding: 10px;
`;

export const SaveButton = styled(Button)`
  float: right;
  margin-right: 6%;
  top: 10px;
  font-weight: bold !important;
`;
export const RuleButton = styled(Button)`
  font-weight: bold !important;
`;
export const LogicAddButton = styled(Button)`
  border: 1px solid #193652 !important;
  font-weight: 700 !important;
`;

export const ParameterSelect = styled(Select)`
  width: 225px;
  display: inline-block;
  margin-right: 1% !important;
`;
export const DeviceSelect = styled(Select)`
  width: 225px;
  display: inline-block;
  margin-right: 1% !important;
`;
export const TagNameSelect = styled(Select)`
  width: 250px;
  margin-right: 1% !important;
`;

export const ColumnNameSelect = styled(Select)`
  width: 120px;
  margin-right: 1%;
`;

export const OperaterSelect = styled(Select)`
  width: 150px;
  margin-right: 1% !important;
`;

export const ValueInput = styled(Input)`
  width: 120px !important;
  margin-right: 1%;
`;

export const ButtonBoxDiv = styled.div`
  width: 40%;
  display: inline-block;
  margin-top: 10px;
`;

export const PickyStyleing = styled(Picky)`
  .picky__input {
    width: 100%;
    border-radius: 4px;
    padding: 5px;
    text-align: left;
    position: relative;
    box-sizing: border-box;
    height: 32px;
  }
  .picky__placeholder {
    font-variant: tabular-nums;
    position: relative;
    bottom: 2px;
    left: 5px;
  }
  .picky__input::after {
    top: 12px;
  }
`;

export const ActionCheckbox = styled(CheckboxGroup)`
  font-weight: 300;
`;

export const Boxdiv = styled.div`
  border-radius: 8px;
  margin: 5px 9px;
  width: 100%;
  margin: 20px 10px;
  padding: 10px;
`;

export const MarginRightButton = styled(Button)`
  margin-right: 10px;
  margin-left: 10px;
  font-weight: 700 !important;
`;
export const OnchangeCheckbox = styled(Checkbox)`
  padding-top: 30px !important;
  margin-left: 50px;
  font-weight: 700;
`;

export const PickyStyling = styled(Picky)`
  .picky__input {
    width: 100%;
    border-radius: 4px;
    padding: 5px;
    text-align: left;
    position: relative;
    box-sizing: border-box;
    height: 32px;
  }
  .picky__placeholder {
    font-variant: tabular-nums;
    position: relative;
    bottom: 2px;
    left: 5px;
  }
  .picky__input::after {
    top: 12px;
  }
`;

export const TextParagraph = styled.p`
  margin-left: 2%;
  display: inline-block;
  
  font-weight:bold;
  padding: 3px;
  border-radius: 4px;
}
`;
